import React, { memo } from "react";
import { Icon, IconProps } from "@chakra-ui/icon";

const VideoFileFooterIcon = (props: IconProps) => (
  <Icon width="17px" height="18px" viewBox="0 0 17 18" {...props}>
    <path d="m6.906 12.75 5-3.75-5-3.75v7.5ZM8.573.667A8.336 8.336 0 0 0 .239 9c0 4.6 3.734 8.333 8.334 8.333S16.906 13.6 16.906 9 13.173.667 8.573.667Zm0 15A6.676 6.676 0 0 1 1.906 9a6.676 6.676 0 0 1 6.667-6.667A6.676 6.676 0 0 1 15.239 9a6.676 6.676 0 0 1-6.666 6.666Z" />
  </Icon>
);

export default memo(VideoFileFooterIcon);
